import type { StepThreeTab } from '../validations/add-template.validation';

import { VariableMappingType } from '../enums/mapping-editor.const';

export const fieldMappingEqual = (
  a: Record<string, string>,
  b: Record<string, string>,
): boolean => {
  const keysA = Object.keys(a);
  const keysB = Object.keys(b);
  if (keysA.length !== keysB.length) return false;
  const sortedEntries = (obj: Record<string, string>) =>
    Object.keys(obj)
      .sort()
      .map((k) => [k, obj[k]]);
  return JSON.stringify(sortedEntries(a)) === JSON.stringify(sortedEntries(b));
};

export const fieldMappingTypesEqual = (
  a: Record<string, VariableMappingType>,
  b: Record<string, VariableMappingType>,
): boolean => {
  const keysA = Object.keys(a);
  const keysB = Object.keys(b);
  if (keysA.length !== keysB.length) return false;
  const sortedEntries = (obj: Record<string, VariableMappingType>) =>
    Object.keys(obj)
      .sort()
      .map((k) => [k, obj[k]]);
  return JSON.stringify(sortedEntries(a)) === JSON.stringify(sortedEntries(b));
};

const tabNorm = (t: StepThreeTab) =>
  [
    t.anchorString ?? '',
    t.type ?? '',
    t.roleName ?? '',
    t.fieldKey ?? '',
    t.value ?? '',
    t.pageNumber ?? '',
    t.xPosition ?? '',
    t.yPosition ?? '',
  ].join('|');

export const tabsEqual = (a: StepThreeTab[], b: StepThreeTab[]): boolean => {
  if (a.length !== b.length) return false;
  const sorted = (arr: StepThreeTab[]) =>
    [...arr].sort((x, y) => tabNorm(x).localeCompare(tabNorm(y)));
  return JSON.stringify(sorted(a).map(tabNorm)) === JSON.stringify(sorted(b).map(tabNorm));
};
